import { render, staticRenderFns } from "./TrainingItem.vue?vue&type=template&id=6a38876f&scoped=true&"
import script from "./TrainingItem.vue?vue&type=script&lang=js&"
export * from "./TrainingItem.vue?vue&type=script&lang=js&"
import style0 from "./TrainingItem.vue?vue&type=style&index=0&id=6a38876f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a38876f",
  null
  
)

export default component.exports